/* Wicked Prop behaviours */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (/wp-static/.test(location.search)) reduce = true;

  /* ---- scroll reveal ---- */
  function initReveal() {
    var els = document.querySelectorAll('.wp-rv, .wp-cascade');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- particles (embers / sparkles / bats) ---- */
  function particles() {
    if (reduce) return;
    document.querySelectorAll('[data-wp-embers]').forEach(function (host) {
      if (host.dataset.wpDone) return; host.dataset.wpDone = '1';
      var n = parseInt(host.dataset.wpEmbers, 10) || 26;
      for (var i = 0; i < n; i++) {
        var e = document.createElement('i'); e.className = 'wp-ember';
        e.style.setProperty('--x', (Math.random() * 100) + '%');
        e.style.setProperty('--d', (5 + Math.random() * 7) + 's');
        e.style.setProperty('--dl', (-Math.random() * 12) + 's');
        e.style.setProperty('--dx', ((Math.random() - .5) * 120) + 'px');
        e.style.setProperty('--s', (0.5 + Math.random() * 1.1).toFixed(2));
        host.appendChild(e);
      }
    });
    document.querySelectorAll('[data-wp-sparkles]').forEach(function (host) {
      if (host.dataset.wpDone) return; host.dataset.wpDone = '1';
      var n = parseInt(host.dataset.wpSparkles, 10) || 18;
      for (var i = 0; i < n; i++) {
        var e = document.createElement('i'); e.className = 'wp-sparkle';
        e.style.setProperty('--x', (Math.random() * 100) + '%');
        e.style.setProperty('--y', (Math.random() * 100) + '%');
        e.style.setProperty('--d', (2 + Math.random() * 3) + 's');
        e.style.setProperty('--dl', (-Math.random() * 5) + 's');
        host.appendChild(e);
      }
    });
    var batSvg = '<svg viewBox="0 0 64 36"><path d="M32 22c-3-8-8-12-14-12-3 0-6 1-8 3 1-5 4-9 8-11-6 0-13 5-18 14 5-3 10-3 14 0-1 5 1 10 5 14 2-4 6-6 9-6 1 3 2 6 4 8 2-2 3-5 4-8 3 0 7 2 9 6 4-4 6-9 5-14 4-3 9-3 14 0-5-9-12-14-18-14 4 2 7 6 8 11-2-2-5-3-8-3-6 0-11 4-14 12z"/></svg>';
    document.querySelectorAll('[data-wp-bats]').forEach(function (host) {
      if (host.dataset.wpDone) return; host.dataset.wpDone = '1';
      var n = parseInt(host.dataset.wpBats, 10) || 6;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('span'); b.className = 'wp-bat'; b.innerHTML = batSvg;
        b.style.setProperty('--t', (5 + Math.random() * 60) + '%');
        b.style.setProperty('--d', (14 + Math.random() * 16) + 's');
        b.style.setProperty('--dl', (-Math.random() * 30) + 's');
        b.style.setProperty('--s', (0.5 + Math.random() * 0.9).toFixed(2));
        host.appendChild(b);
      }
    });
  }

  /* ---- countdown ---- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdown() {
    document.querySelectorAll('[data-wp-countdown]').forEach(function (el) {
      var deadline = new Date(el.dataset.wpCountdown).getTime();
      if (isNaN(deadline)) return;
      var d = el.querySelector('[data-wp-d]'), h = el.querySelector('[data-wp-h]'), m = el.querySelector('[data-wp-m]'), s = el.querySelector('[data-wp-s]');
      function tick() {
        var left = deadline - Date.now();
        if (left <= 0) { el.classList.add('is-over'); return; }
        var sec = Math.floor(left / 1000);
        var days = Math.floor(sec / 86400); sec -= days * 86400;
        var hrs = Math.floor(sec / 3600); sec -= hrs * 3600;
        var min = Math.floor(sec / 60); sec -= min * 60;
        if (d) d.textContent = pad(days); if (h) h.textContent = pad(hrs); if (m) m.textContent = pad(min); if (s) s.textContent = pad(sec);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---- toast ---- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'wp-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---- cart adds ---- */
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add'); }); return r.json(); });
  }
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-wp-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: c } }));
    }).catch(function () {});
  }

  /* ---- add to cart through the theme's own event system, so the Horizon cart drawer re-renders and opens ----
     NOTE: never use import() here — Shopify's asset minifier rewrites it to require() and the call throws.
     The event class is fetched by an injected <script type="module"> that resolves through the theme's import map. */
  var evReady;
  function loadCartEvents() {
    if (evReady) return evReady;
    evReady = new Promise(function (resolve) {
      if (window.__wpCartEvents) return resolve(window.__wpCartEvents);
      var done = false;
      function finish(v) { if (!done) { done = true; resolve(v || null); } }
      document.addEventListener('wp:cart-events', function (e) { finish(e.detail); }, { once: true });
      try {
        var sc = document.createElement('script'); sc.type = 'module';
        sc.textContent = "import * as m from '@shopify/events'; window.__wpCartEvents = m; document.dispatchEvent(new CustomEvent('wp:cart-events', { detail: m }));";
        sc.onerror = function () { finish(null); };
        document.head.appendChild(sc);
      } catch (er) { finish(null); }
      setTimeout(function () { finish(null); }, 4000);
    });
    return evReady;
  }
  function openDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
  }
  function swapSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var host = document.getElementById('shopify-section-' + id); if (!host) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var curInner = host.querySelector('[data-hydration-key="cart-drawer-inner"]');
      var newInner = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
      if (curInner && newInner) { curInner.innerHTML = newInner.innerHTML; curInner.className = newInner.className; return; }
      var fresh = doc.getElementById('shopify-section-' + id) || doc.body;
      host.innerHTML = fresh.innerHTML;
    });
  }
  /* apply a discount code to the session (Shopify sets it via the /discount/CODE redirect), then re-render the drawer */
  function applyDiscount(code) {
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart', { credentials: 'same-origin', redirect: 'follow' })
      .catch(function () {})
      .then(function () { return refreshDrawer(); });
  }
  function refreshDrawer() {
    var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (e) { return e.dataset.sectionId; }).filter(Boolean);
    if (!ids.length) return Promise.resolve();
    return fetch('/?sections=' + ids.join(','), { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (sections) { swapSections(sections); refreshCartCount(); }).catch(function () {});
  }
  function cartAdd(items) {
    return loadCartEvents().then(function (m) {
      var Ev = m && m.CartLinesUpdateEvent;
      var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (e) { return e.dataset.sectionId; }).filter(Boolean);
      var deferred = Ev && Ev.createPromise ? Ev.createPromise() : null;
      if (Ev) {
        document.dispatchEvent(new Ev({ action: 'add', context: 'product',
          lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
          promise: deferred ? deferred.promise : undefined }));
      }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items, sections: ids.join(',') }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
        .then(function (data) {
          return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (ajaxCart) {
            if (deferred && deferred.resolve) {
              deferred.resolve({
                cart: ajaxCart && Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(ajaxCart) : undefined,
                detail: { items: ajaxCart ? ajaxCart.items : [], source: 'wp-buy', sections: data.sections, didError: false }
              });
            } else {
              swapSections(data.sections);
            }
            openDrawer();
            document.querySelectorAll('[data-wp-cart-count]').forEach(function (n) { if (ajaxCart) n.textContent = ajaxCart.item_count; });
            return data;
          });
        })
        .catch(function (err) { if (deferred && deferred.resolve) deferred.resolve({ detail: { didError: true } }); throw err; });
    });
  }
  function initCartUpsell() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wp-cart-add]'); if (!btn || btn.disabled) return;
      e.preventDefault(); btn.classList.add('is-busy');
      var code = btn.dataset.wpDiscount || '';
      var pick = btn.closest('[data-wp-pick]'), sel = pick && pick.querySelector('select[data-wp-variant]');
      var vid = parseInt(btn.dataset.wpCartAdd, 10) || (sel && parseInt(sel.value, 10));
      if (!vid) { btn.classList.remove('is-busy'); return; }
      var items = [{ id: vid, quantity: 1 }];
      var p = code ? addItems(items).then(function () { return applyDiscount(code); }).then(function () { openDrawer(); }) : cartAdd(items);
      p.catch(function (err) { toast(err.message || 'Could not add'); }).then(function () { btn.classList.remove('is-busy'); });
    });
  }
  function initBuy() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wp-buy]');
      if (!btn) return;
      e.preventDefault();
      var ids = String(btn.dataset.wpBuy).split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
      if (!ids.length) return;
      var mode = btn.dataset.wpMode || 'checkout';
      var discount = btn.dataset.wpDiscount || '';
      var label = btn.innerHTML;
      btn.classList.add('is-busy'); btn.innerHTML = 'Adding…';
      var scope = btn.closest('[data-wp-pdp]');
      var qtyEl = scope && scope.querySelector('[data-wp-qty-input]');
      var q = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      var items = null;
      if (btn.dataset.wpItems) { try { items = JSON.parse(btn.dataset.wpItems); } catch (er) { items = null; } }
      if (!items || !items.length) items = ids.map(function (id) { return { id: id, quantity: q }; });
      if (mode === 'cart') {
        cartAdd(items).then(function () { btn.classList.remove('is-busy'); btn.innerHTML = label; })
          .catch(function (err) { btn.classList.remove('is-busy'); btn.innerHTML = label; toast(err.message || 'Sold out right now'); });
        return;
      }
      addItems(items).then(function () {
        btn.classList.remove('is-busy');
        if (mode === 'cart') {
          btn.classList.add('is-done'); btn.innerHTML = 'Added ✓';
          toast('Added to your bag');
          refreshCartCount();
          setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = label; }, 2200);
        } else {
          btn.innerHTML = 'Taking you to checkout…';
          var url = discount ? '/discount/' + encodeURIComponent(discount) + '?redirect=%2Fcheckout' : '/checkout';
          window.location.href = url;
        }
      }).catch(function (err) {
        btn.classList.remove('is-busy'); btn.innerHTML = label;
        toast(err.message || 'Sold out right now');
      });
    });
  }

  /* ---- tabs ---- */
  function initTabs() {
    document.querySelectorAll('[data-wp-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-wp-tab]'), panels = root.querySelectorAll('[data-wp-panel]');
      function go(key) {
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.wpTab === key); t.setAttribute('aria-selected', t.dataset.wpTab === key); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.wpPanel === key); });
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { go(t.dataset.wpTab); }); });
      var initial = root.dataset.wpTabs || (tabs[0] && tabs[0].dataset.wpTab);
      var match = Array.prototype.some.call(tabs, function (t) { return t.dataset.wpTab === initial; });
      go(match ? initial : (tabs[0] && tabs[0].dataset.wpTab));
    });
  }

  /* ---- lightbox + show more ---- */
  function initLightbox() {
    var lb = document.querySelector('[data-wp-lightbox]');
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'wp-lb'; lb.setAttribute('data-wp-lightbox', '');
      lb.innerHTML = '<button type="button" class="wp-lb__x" aria-label="Close">×</button><div data-wp-lb-body></div>';
      document.body.appendChild(lb);
    }
    var body = lb.querySelector('[data-wp-lb-body]');
    function close() { lb.classList.remove('is-open'); body.innerHTML = ''; document.body.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-wp-zoom]');
      if (t) {
        e.preventDefault();
        var src = t.dataset.wpZoom, kind = t.dataset.wpKind || 'image';
        body.innerHTML = kind === 'video' ? '<video src="' + src + '" controls autoplay playsinline></video>' : '<img src="' + src + '" alt="">';
        lb.classList.add('is-open'); document.body.style.overflow = 'hidden';
        return;
      }
      if (e.target === lb || e.target.classList.contains('wp-lb__x')) close();
      var more = e.target.closest('[data-wp-more]');
      if (more) {
        var scope = more.closest('[data-wp-more-scope]') || document;
        scope.querySelectorAll('.is-hidden').forEach(function (c) { c.classList.remove('is-hidden'); });
        more.parentNode.style.display = 'none';
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- inline videos: play when visible, pause when not ---- */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-wp-autoplay]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) v.play().catch(function () {}); else v.pause(); });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---- sticky bar on product page ---- */
  function initSticky() {
    var bar = document.querySelector('[data-wp-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('product-form, [data-wp-sticky-anchor], .product-form');
    function check() {
      var past = anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      bar.classList.toggle('is-visible', past);
    }
    window.addEventListener('scroll', check, { passive: true }); check();
  }


  /* ---- bespoke product buy box ---- */
  function money(cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var n = (cents / 100).toFixed(2);
    return (fmt === 'HKD' ? 'HK$' : fmt === 'USD' ? '$' : fmt === 'GBP' ? '£' : fmt === 'EUR' ? '€' : '$') + n;
  }
  function initPdp() {
    var root = document.querySelector('[data-wp-pdp]');
    if (!root) return;
    var product; try { product = JSON.parse(root.dataset.wpProduct); } catch (e) { product = null; }
    var slides = root.querySelectorAll('[data-wp-slide]'), thumbs = root.querySelectorAll('[data-wp-thumb]');
    var idx = 0;
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      root.querySelectorAll('.wp-pdp__dots i').forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      var v = slides[idx].querySelector('video'); if (v) v.play().catch(function () {});
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = root.querySelector('[data-wp-prev]'), next = root.querySelector('[data-wp-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    var main = root.querySelector('.wp-pdp__main'), sx = 0;
    if (main) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); }, { passive: true });
    }
    // quantity
    root.querySelectorAll('[data-wp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = root.querySelector('[data-wp-qty-input]');
        inp.value = Math.min(10, Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.wpQty, 10)));
      });
    });
    // swatches
    var swatches = root.querySelectorAll('[data-wp-variant]');
    function selectVariant(id) {
      var v = product && product.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      swatches.forEach(function (s) { var on = s.dataset.wpVariant === String(id); s.classList.toggle('is-active', on); s.setAttribute('aria-checked', on); });
      var ov = root.querySelector('[data-wp-opt-value]'); if (ov) ov.textContent = v.title;
      var p = root.querySelector('[data-wp-price]'); if (p) p.textContent = money(v.price);
      var c = root.querySelector('[data-wp-compare]'), sv = root.querySelector('[data-wp-save]');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (c) { c.textContent = money(v.compare_at_price); c.hidden = false; }
        if (sv) { sv.textContent = 'You save ' + money(v.compare_at_price - v.price) + ' (' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off)'; sv.hidden = false; }
      } else { if (c) c.hidden = true; if (sv) sv.hidden = true; }
      root.querySelectorAll('[data-wp-main-buy]').forEach(function (b) {
        b.dataset.wpBuy = v.id; b.disabled = !v.available;
        if (b.classList.contains('wp-pdp__atc')) b.textContent = v.available ? (b.dataset.wpLabel || b.textContent.replace('Sold out', 'Add to bag')) : 'Sold out';
      });
      var sticky = document.querySelector('[data-wp-sticky] [data-wp-buy]'); if (sticky) sticky.dataset.wpBuy = v.id;
      var sp = document.querySelector('[data-wp-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var mediaId = (swatches.length && Array.prototype.filter.call(swatches, function (s) { return s.dataset.wpVariant === String(id); })[0] || {}).dataset;
      mediaId = mediaId && mediaId.wpMedia;
      if (mediaId) { slides.forEach(function (s, n) { if (s.dataset.wpSlide === mediaId) show(n); }); }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      if (root._wpTierSync) root._wpTierSync(v.id);
    }
    swatches.forEach(function (s) { s.addEventListener('click', function () { selectVariant(s.dataset.wpVariant); }); });
    var atc = root.querySelector('.wp-pdp__atc'); if (atc) atc.dataset.wpLabel = (atc.firstChild && atc.firstChild.nodeType === 3 ? atc.firstChild.nodeValue : atc.textContent).trim();
    // ---- multi-buy tiers ----
    var tiersRoot = root.querySelector('[data-wp-tiers]');
    if (tiersRoot && product) {
      var tierEls = Array.prototype.slice.call(tiersRoot.querySelectorAll('[data-wp-tier]'));
      var unit = tiersRoot.dataset.wpUnit || 'unit', units = tiersRoot.dataset.wpUnits || 'units', slotLabel = tiersRoot.dataset.wpSlot || 'Item';
      var variants = product.variants;
      var byId = function (id) { return variants.filter(function (x) { return String(x.id) === String(id); })[0]; };
      var activeSw = root.querySelector('[data-wp-variant].is-active');
      var baseId = activeSw ? activeSw.dataset.wpVariant : (variants.filter(function (x) { return x.available; })[0] || variants[0]).id;
      var state = { q: parseInt(tiersRoot.dataset.wpDefault, 10) || 1, slots: [] };
      if (!tierEls.some(function (t) { return parseInt(t.dataset.wpTier, 10) === state.q; })) state.q = parseInt(tierEls[0].dataset.wpTier, 10) || 1;
      function fill() { while (state.slots.length < 4) state.slots.push(baseId); }
      fill();
      function variantThumb(v) {
        var img = v.featured_image && (v.featured_image.src || v.featured_image);
        if (!img && product.featured_image) img = product.featured_image;
        if (typeof img !== 'string') return '';
        return img.replace(/(\.[a-z]+)(\?|$)/i, '_120x120_crop_center$1$2');
      }
      function renderSlots() {
        tierEls.forEach(function (t) {
          var host = t.querySelector('[data-wp-slots]'); if (!host) return;
          var q = parseInt(t.dataset.wpTier, 10);
          if (q !== state.q) { host.innerHTML = ''; return; }
          var html = '';
          for (var i = 0; i < q; i++) {
            var cur = byId(state.slots[i]) || variants[0];
            html += '<div class="wp-slot" data-wp-slot-i="' + i + '"><div class="wp-slot__lab">' + slotLabel + ' ' + (i + 1) + '<b>' + cur.title + '</b></div><div class="wp-slot__opts" role="radiogroup">';
            variants.forEach(function (v) {
              var on = String(v.id) === String(state.slots[i]);
              html += '<button type="button" class="wp-slot__opt' + (on ? ' is-active' : '') + (v.available ? '' : ' is-soldout') + '" data-wp-slot-pick="' + v.id + '" role="radio" aria-checked="' + on + '" title="' + v.title.replace(/"/g, '&quot;') + (v.available ? '' : ' — sold out') + '"' + (v.available ? '' : ' aria-disabled="true"') + '>' + v.title + '</button>';
            });
            html += '</div></div>';
          }
          host.innerHTML = html;
        });
      }
      function items() {
        var map = {}, order = [];
        for (var i = 0; i < state.q; i++) { var id = state.slots[i]; if (!map[id]) { map[id] = 0; order.push(id); } map[id]++; }
        return order.map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
      }
      function render() {
        var sel = tierEls.filter(function (t) { return parseInt(t.dataset.wpTier, 10) === state.q; })[0];
        var pct = sel ? parseInt(sel.dataset.wpPct, 10) || 0 : 0;
        var base = byId(baseId) || variants[0];
        // per-tier numbers (unselected tiers priced on the current main variant)
        tierEls.forEach(function (t) {
          var q = parseInt(t.dataset.wpTier, 10), tp = parseInt(t.dataset.wpPct, 10) || 0, sub = 0, was = 0;
          if (q === state.q) { for (var i = 0; i < q; i++) { var v = byId(state.slots[i]) || base; sub += v.price; was += (v.compare_at_price || v.price); } }
          else { sub = base.price * q; was = (base.compare_at_price || base.price) * q; }
          var tot = Math.round(sub * (100 - tp) / 100);
          var tt = t.querySelector('[data-wp-tier-total]'), tw = t.querySelector('[data-wp-tier-was]'), te = t.querySelector('[data-wp-tier-each]');
          if (tt) tt.textContent = money(tot);
          if (tw) { tw.textContent = money(was); tw.hidden = !(was > tot); }
          if (te) te.textContent = money(Math.round(tot / q)) + ' each';
          var on = q === state.q; t.classList.toggle('is-active', on); t.setAttribute('aria-checked', on);
        });
        // selected totals
        var sub = 0, was = 0, ok = true;
        for (var i = 0; i < state.q; i++) { var v = byId(state.slots[i]) || base; sub += v.price; was += (v.compare_at_price || v.price); if (!v.available) ok = false; }
        var tot = Math.round(sub * (100 - pct) / 100);
        var p = root.querySelector('[data-wp-price]'); if (p) p.textContent = money(tot);
        var c = root.querySelector('[data-wp-compare]'), sv = root.querySelector('[data-wp-save]');
        if (was > tot) { if (c) { c.textContent = money(was); c.hidden = false; } if (sv) { sv.textContent = 'Save ' + Math.round((was - tot) * 100 / was) + '%'; sv.hidden = false; } }
        else { if (c) c.hidden = true; if (sv) sv.hidden = true; }
        var each = root.querySelector('[data-wp-price-each]');
        if (!each && p) { each = document.createElement('span'); each.className = 'wp-pdp__price-each'; each.setAttribute('data-wp-price-each', ''); p.parentNode.appendChild(each); }
        if (each) each.textContent = state.q > 1 ? money(Math.round(tot / state.q)) + ' each · ' + state.q + ' ' + units : '';
        var sum = root.querySelector('[data-wp-atc-sum]'); if (sum) sum.textContent = state.q > 1 ? state.q + ' × · ' + money(tot) : money(tot);
        var its = JSON.stringify(items());
        root.querySelectorAll('[data-wp-main-buy]').forEach(function (b) {
          b.dataset.wpItems = its; b.disabled = !ok;
          if (b.classList.contains('wp-pdp__atc')) { var lab = b.dataset.wpLabel || 'Add to bag'; b.firstChild.nodeValue = ok ? lab : 'Sold out'; }
        });
        var st = document.querySelector('[data-wp-sticky] [data-wp-buy]'); if (st) { st.dataset.wpItems = its; }
        var sp = document.querySelector('[data-wp-sticky-price]'); if (sp) sp.textContent = money(tot);
        var sc = document.querySelector('[data-wp-sticky-compare]'); if (sc) { sc.textContent = money(was); sc.hidden = !(was > tot); }
        var ss = document.querySelector('[data-wp-sticky-sub]'); if (ss) ss.textContent = state.q + ' ' + (state.q === 1 ? unit : units) + (pct ? ' · save ' + pct + '%' : '');
        renderSlots();
      }
      tierEls.forEach(function (t) {
        var pick = function () { state.q = parseInt(t.dataset.wpTier, 10) || 1; fill(); render(); };
        t.addEventListener('click', function (e) { if (e.target.closest('[data-wp-slot-pick]')) return; pick(); });
        t.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(); } });
      });
      tiersRoot.addEventListener('click', function (e) {
        var b = e.target.closest('[data-wp-slot-pick]'); if (!b) return;
        var v = byId(b.dataset.wpSlotPick); if (!v || !v.available) { toast(v ? v.title + ' is sold out' : 'Unavailable'); return; }
        var i = parseInt(b.closest('[data-wp-slot-i]').dataset.wpSlotI, 10);
        state.slots[i] = String(v.id);
        if (i === 0) { baseId = String(v.id); root._wpTierSilent = true; selectVariant(v.id); root._wpTierSilent = false; }
        render();
      });
      root._wpTierSync = function (id) {
        if (root._wpTierSilent) return;
        baseId = String(id); state.slots[0] = baseId; render();
      };
      // make the ATC label restorable: keep text in a text node so the sum span survives
      var atcBtn = root.querySelector('.wp-pdp__atc');
      if (atcBtn && atcBtn.firstChild && atcBtn.firstChild.nodeType !== 3) atcBtn.insertBefore(document.createTextNode(atcBtn.dataset.wpLabel || 'Add to bag'), atcBtn.firstChild);
      render();
    }

    // rotating review quotes under the buy button
    var qroot = root.querySelector('[data-wp-quotes]');
    if (qroot) {
      var qs = qroot.querySelectorAll('.wp-pdp__quote'), qd = qroot.querySelectorAll('.wp-pdp__quote-dots i'), qi = 0;
      if (qs.length > 1 && !reduce) {
        setInterval(function () {
          qi = (qi + 1) % qs.length;
          qs.forEach(function (q, n) { q.classList.toggle('is-active', n === qi); });
          qd.forEach(function (d, n) { d.classList.toggle('is-active', n === qi); });
        }, 4200);
      }
    }
    // delivery estimate
    var d = root.querySelector('[data-wp-delivery]');
    if (d) {
      var now = new Date(), cutoff = parseInt(d.dataset.wpCutoff, 10) || 16;
      var ships = new Date(now); if (now.getHours() >= cutoff) ships.setDate(ships.getDate() + 1);
      if (ships.getDay() === 0) ships.setDate(ships.getDate() + 1);
      var a = new Date(ships), b = new Date(ships);
      a.setDate(a.getDate() + (parseInt(d.dataset.wpDaysMin, 10) || 5)); b.setDate(b.getDate() + (parseInt(d.dataset.wpDaysMax, 10) || 9));
      var f = function (x) { return x.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
      var line = d.querySelector('[data-wp-delivery-line]'), eta = d.querySelector('[data-wp-delivery-eta]');
      if (line) line.textContent = 'Free tracked delivery to your door.';
      if (eta) eta.textContent = 'Order today: estimated arrival ' + f(a) + ' – ' + f(b) + '.';
    }
  }


  /* ---- wand arena: burst fire, spark trail, parallax ---- */
  function initStage() {
    document.querySelectorAll('[data-wp-stage]').forEach(function (stage) {
      if (stage.dataset.wpDone) return; stage.dataset.wpDone = '1';
      var cv = stage.querySelector('[data-wp-stage-trail]'), wands = stage.querySelectorAll('[data-wp-stage-wand]');
      if (!cv || reduce) return;
      var ctx = cv.getContext('2d'), parts = [], running = false, raf = 0, W = 0, H = 0, dpr = Math.min(2, window.devicePixelRatio || 1), last = {}, timers = [];
      function size() { var r = stage.getBoundingClientRect(); W = r.width; H = r.height; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      size(); window.addEventListener('resize', size);
      function spawn(x, y, vx, vy, n, burst) {
        for (var i = 0; i < n; i++) {
          var ang = Math.random() * Math.PI * 2, sp = burst ? 1.5 + Math.random() * 3.5 : 0.4 + Math.random() * 1.2;
          parts.push({ x: x + (Math.random() - .5) * 5, y: y + (Math.random() - .5) * 5, vx: (burst ? Math.cos(ang) * sp : -vx * .25 + (Math.random() - .5) * 1.4), vy: (burst ? Math.sin(ang) * sp - .8 : -vy * .25 - .6 - Math.random() * 1.2), life: 1, decay: (burst ? .012 : .018) + Math.random() * .02, r: 1.2 + Math.random() * (burst ? 2.8 : 2.2), hue: 18 + Math.random() * 30 });
        }
        if (parts.length > 320) parts.splice(0, parts.length - 320);
      }
      function tipPos(w) { var t = w.querySelector('[data-wp-tip]'), sr = stage.getBoundingClientRect(), r = t.getBoundingClientRect(); return { x: r.left - sr.left + 1, y: r.top - sr.top + 1 }; }
      function frame() {
        if (!running) return;
        wands.forEach(function (w) {
          var k = w.dataset.wpStageWand, p = tipPos(w), q = last[k] || p;
          if (w.classList.contains('is-firing')) spawn(p.x, p.y, p.x - q.x, p.y - q.y, 3, false);
          else if (Math.random() < .12) spawn(p.x, p.y, 0, 0, 1, false);
          last[k] = p;
        });
        ctx.clearRect(0, 0, W, H); ctx.globalCompositeOperation = 'lighter';
        for (var i = parts.length - 1; i >= 0; i--) {
          var q = parts[i]; q.x += q.vx; q.y += q.vy; q.vy -= .015; q.vx *= .985; q.life -= q.decay;
          if (q.life <= 0) { parts.splice(i, 1); continue; }
          var a = Math.max(0, q.life);
          ctx.beginPath(); ctx.arc(q.x, q.y, q.r * (0.5 + a), 0, Math.PI * 2);
          ctx.fillStyle = 'hsla(' + q.hue + ',100%,' + (55 + a * 30) + '%,' + (a * .85) + ')'; ctx.fill();
        }
        ctx.globalCompositeOperation = 'source-over';
        raf = requestAnimationFrame(frame);
      }
      // burst-fire cycle: idle -> ignite (burst of sparks) -> burn -> die -> idle
      function cycle(w, delay) {
        var t = setTimeout(function () {
          if (!running) { cycle(w, 800); return; }
          var p = tipPos(w); spawn(p.x, p.y, 0, 0, 26, true);
          w.classList.remove('is-dying'); w.classList.add('is-firing');
          var burn = 1300 + Math.random() * 1500;
          timers.push(setTimeout(function () {
            w.classList.remove('is-firing'); w.classList.add('is-dying');
            timers.push(setTimeout(function () { w.classList.remove('is-dying'); }, 700));
            cycle(w, 1600 + Math.random() * 3200);
          }, burn));
        }, delay);
        timers.push(t);
      }
      wands.forEach(function (w, i) { cycle(w, 600 + i * 1400 + Math.random() * 800); });
      function start() { if (running) return; running = true; raf = requestAnimationFrame(frame); }
      function stop() { running = false; cancelAnimationFrame(raf); }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { en.isIntersecting ? start() : stop(); }); }, { threshold: .05 }).observe(stage); else start();
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      var host = stage.parentNode;
      if (stage.dataset.wpStageMode !== 'section' && window.matchMedia && matchMedia('(pointer:fine)').matches && host) {
        var tx = 0, ty = 0, cx = 0, cy = 0, pr = 0;
        function ease() { cx += (tx - cx) * .08; cy += (ty - cy) * .08; stage.style.transform = 'rotateX(' + (-cy * 5).toFixed(2) + 'deg) rotateY(' + (cx * 7).toFixed(2) + 'deg)'; if (Math.abs(tx - cx) > .002 || Math.abs(ty - cy) > .002) pr = requestAnimationFrame(ease); else pr = 0; }
        host.addEventListener('pointermove', function (e) { var r = stage.getBoundingClientRect(); tx = ((e.clientX - r.left) / r.width - .5); ty = ((e.clientY - r.top) / r.height - .5); if (!pr) pr = requestAnimationFrame(ease); });
        host.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!pr) pr = requestAnimationFrame(ease); });
      }
    });
  }

  function init() { initCartUpsell(); initStage(); initPdp(); initReveal(); particles(); initCountdown(); initBuy(); initTabs(); initLightbox(); initVideos(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initStage(); initReveal(); particles(); initTabs(); initVideos(); initCountdown(); });
})();
